export interface SensorScatterplotData {
  id: string
  name: string
  description: string
  /** Custom or computed bound; undefined while there is no data/override. */
  yMin?: number
  yMax?: number
  color: string
  isDerived?: boolean
  currentValue?: number | null
  unit?: string
  xValue?: number | string | null
  xUnit?: string
}

export type SensorData = {
  name: string
  description?: string
  unit?: string
  asset?: string
  upper_threshold?: number
  lower_threshold?: number
  upper_upper_threshold?: number
  lower_lower_threshold?: number
  value?: number | null
  instrument_tag?: string
  source_tag?: string
  point_source?: string
}

export type BaseSensorEntry = {
  id: string
  type: string
  data: SensorData
  tags: {
    [key: string]: string | null
  }
  updated_at?: string
  created_at?: string
  last_updated_by?: string
}

export interface SensorThresholdConfig {
  sensorId: string
  enabled: boolean
  lowerLowerThreshold: number | null
  lowerThreshold: number | null
  upperThreshold: number | null
  upperUpperThreshold: number | null
}

export type SensorEntryWrapper = {
  entry: BaseSensorEntry
}

export type LocalThresholdOverrideType = Record<string, SensorThresholdConfig>

export type SensorAxisMapping = Record<
  string,
  { axis: string; side: 'left' | 'right'; index: number }
>

export type SensorAxisAssignment = Record<
  string,
  { side: 'left' | 'right'; index: number }
>

export type EnhancedSensorEntry = BaseSensorEntry & {
  data: SensorData & {
    thresholds?: SensorThresholdConfig
  }
}
